import { USER_TYPES } from "../types";

const default_state = {
  client_secret: "",
  client_key: "",
  auth_token: "",
  name: "",
  role: "",
  loading: false,
  error: false,
  permissions: {},
  user: JSON.parse(localStorage.getItem("user")),
};

const reducer = (state = default_state, action) => {
  switch (action.type) {
    case USER_TYPES.USER_LOGIN:
      return {
        ...state,
        loading: action.payload,
      };
    case USER_TYPES.USER_LOGIN_SUCCESS:
      localStorage.setItem("user", JSON.stringify(action.payload));
      return {
        ...state,
        name: action.payload.name,
        user: action.payload,
      };
    case USER_TYPES.USER_REGISTER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case USER_TYPES.USER_LOGOUT:
        localStorage.removeItem("user")
        return {
            ...state,
            loading: action.payload,
            user: null
        }
    default:
      return state;
  }
};

export default reducer;
